import {ALLOWED_PARAM_CHARS} from 'src/internal/addCarryOverIdentifiers';

export const SECTION_WITH_CARRY_OVER_PARAM_OPTIONAL_REGEX = new RegExp(
  `({${ALLOWED_PARAM_CHARS.source}})[!|?]`,
  'g',
);

export default function stripTrailingSlash(url: string): string {
  if (!url.endsWith('/') || url.length === 1) {
    return url;
  }

  const urlWithoutCarryOver = url.replace(
    SECTION_WITH_CARRY_OVER_PARAM_OPTIONAL_REGEX,
    '',
  );

  if (urlWithoutCarryOver.length > 1) {
    return url.slice(0, -1);
  }

  return url;
}
